import React from 'react';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/rx-refills-list';

const _memberPrescriptionRefillsWidget = ( props ) => {
    return (
        <div className='ui-member-prescription-refills-widget'>
            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                onActionClick={ props.onActionClick }
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
                disablePagination={ true }
            />
        </div>
    );
};

// set display name
_memberPrescriptionRefillsWidget.displayName = 'memberPrescriptionRefillsWidget';

// set default props
_memberPrescriptionRefillsWidget.defaultProps = {};

// prop types
_memberPrescriptionRefillsWidget.propTypes = {};

/*************************************** */

const memberPrescriptionRefillsWidgetPreloader = ( ) => {
    return (
        <div className='ui-order-details-prescriptions-preloaderr'>
            <TableSearchInlineWidgetPreloader
                className='ui-order-details-prescriptions-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberPrescriptionRefillsWidgetPreloader.displayName = 'memberPrescriptionRefillsWidgetPreloader';

// set default props
memberPrescriptionRefillsWidgetPreloader.defaultProps = {};

// prop types
memberPrescriptionRefillsWidgetPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberPrescriptionRefillsWidget as MemberPrescriptionRefillsWidget } from 'ui/views/widgets/memberPrescriptionRefillsWidget';
 *
 * // render
 * <MemberPrescriptionRefillsWidget propName='propValue'/>
 */
export const memberPrescriptionRefillsWidget = withNetworkState( memberPrescriptionRefillsWidgetPreloader, _memberPrescriptionRefillsWidget );

